import { LazyHelmet } from '../../base'

import { useNavigate } from 'react-router-dom'
import { app_name, static_img_url } from '../Variables'
import LazyImage from './LazyImage'
import { ScrollToTop } from '../CodeEasier'

function NotFound404() {
  const navigate = useNavigate()
  return (
    // <section>
      <div className='handlers'>
        <LazyHelmet>
          <title>404 ~ {app_name}</title>
        </LazyHelmet>



        <ScrollToTop />
        <LazyImage src={`${static_img_url}/handlers/error404.webp`} alt={'Image'} />
        <div className='mt-3 mb-3'>Oops ! Requested page not found. " Inavlid Url "</div>
        <button className='primaryButton h6' onClick={() => navigate('/')}>Go To Home</button>
      </div>
      // </section>
  )
}

export default NotFound404